import { render, staticRenderFns } from "./EditPageContact.vue?vue&type=template&id=c1ec3958"
import script from "./EditPageContact.vue?vue&type=script&lang=js"
export * from "./EditPageContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports